



























































import { Component, Vue, Prop } from "vue-property-decorator";
import { getCarModels, getSeriesInfo } from "../api/selectType";
@Component
export default class selectType extends Vue {
  @Prop({}) selectMsg!: any;
  $route: any;
  $store: any;
  $router: any;
  seriesId: any = "";
  seriesInfoData: any = {};
  carModelsData: any[] = [
    {
      yearModelList: [
        {
          disModelList: [],
        },
      ],
    },
  ];
  nkIndex: any = 0;
  cxCurrentIndex: any = null;
  selectOne: any = {};
  //返回上一页
  goBack() {}

  mounted() {
    this.getCarModelsData();
    this.getSeriesInfoData();
  }
  changeNkIndex(index: any) {
    this.nkIndex = index;
  }
  changeCxIndex(index: any, item: any) {
    this.cxCurrentIndex = index;
    this.selectOne = item;
  }
  submitSelectOne(params: any) {
    if (params) {
      this.$emit("getSelectOne", this.selectOne);
    } else {
      this.$emit("getSelectOne", "");
    }
  }
  getCarModelsData() {
    let params: any = {
      seriesId: this.selectMsg,
    };
    getCarModels(params).then((res: any) => {
      //返回值
      this.carModelsData = res.data;
    });
  }
  getSeriesInfoData() {
    let params: any = {
      seriesId: this.selectMsg,
    };
    getSeriesInfo(params).then((res: any) => {
      //返回值
      this.seriesInfoData = res.data;
    });
  }
}
